<template>
<div class="foot-hd">
  <div class="link mart20">
    <div class="w1200 linkc">
      <img src="../../images/zxxz/link.png">
      <span>友情链接</span>
      <select @change="moveTo(1)" id="link1">
        <option>血站网站链接</option>
        <option v-for="(item,index) in linkList1" :value="item.url">{{item.name}}</option>
      </select>
      <select @change="moveTo(2)" id="link2">
        <option>热门网站链接</option>
        <option v-for="(item,index) in linkList2" :value="item.url"><a :href="item.url" target="_blank">{{item.name}}</a></option>
      </select>
      <select @change="moveTo(3)" id="link3">
        <option>政府网站链接</option>
        <option v-for="(item,index) in linkList3" :value="item.url"><a :href="item.url" target="_blank">{{item.name}}</a></option>
      </select>
    </div>
  </div>
  <div class="footer">
    <div class="w1200 ">

      <div class="footert">
          <span v-for="(item,index) in navList">
              <a :href="item.web_url">{{item.name}}</a>
              <span v-show="index+1 < navList.length"> | </span>
          </span>
      </div>
      <div class="clear footerb">
        <img src="../../images/zxxz/sydw.png" class="floatL footerbl">
        <div class="floatL footerbr">
          <p> 主办单位：{{siteData.company_name}}  ©版权所有：未经许可，不得复制、转载</p>
          <p> 通讯地址：{{siteData.address}}           传真：{{siteData.fax}}</p>
          <p> 联系电话：{{siteData.phone}}</p>
          <p> <a href="https://beian.miit.gov.cn/#/Integrated/index">备案号： {{siteData.beian}}</a></p>

        </div>
        <div class="footerbla floatR" v-show="siteData.qr_code != null && siteData.qr_code != '' && siteData.qr_code != undefined">
          <img :src="siteData.qr_code" class=" imgcode">
          <p>微信公众号</p>
        </div>
      </div>
    </div>
  </div>

</div>
</template>

<script>
    export default {
        name: "tFoot",
        data() {
            return {
                navList: [{},{},{},{}],
                linkList1: [],
                linkList2: [],
                linkList3: [],
                siteData: [],
            };
        },
        mounted() {
            this.getFootNav();
            this.getSiteData();
            this.getFriendLinkList();
        },
        methods: {
            getFootNav: async function() {
                let res = await this.$getJSON('nav/getFootNav');
                this.navList = res.data.navList;
            },
            getSiteData: async function() {
                let res = await this.$getJSON('index/getSiteData');
                this.siteData = res.data.siteData;
            },
            getFriendLinkList : async function() {
                let res = await this.$getJSON('index/getFriendLinkList');
                this.linkList1 = res.data.linkList1;
                this.linkList2 = res.data.linkList2;
                this.linkList3 = res.data.linkList3;
            },
            moveTo: function (type) {

                let url = document.getElementById("link"+type).value;
                if(url != null && url != '' && url != undefined) {
                    window.open(url,'_blank');
                }
            }
        }
    }
</script>

<style lang="scss">
.foot-hd{
  .link{
    background: #f8f8f8;
    border-top: 2px solid #fd2167;
    height: 90px;
    padding: 23px 0;
    box-sizing: border-box;
    font-size: 20px;
    color: #000;
    line-height: 44px;
    font-weight: bolder;
  }
  .linkc select{
    width: 300px;
    height: 44px;
    font-size: 16px;
    margin-left: 40px;
    border: 1px solid #eee;
    padding: 0 15px;
    appearance: none;
    　-moz-appearance: none;
    -webkit-appearance: none;
    background: #fff url("../../images/zxxz/xx.png") no-repeat scroll right center;
    background-position-x: 270px;
    outline:none;
  }

  .linkc img{
    width: 50px;
    margin-right: 10px;
    vertical-align: middle;
    display: inline-block;
  }
  select::-ms-expand {
    　　display: none;
  }
  .footer{
    background: #fd2167;
    padding: 38px 0;
    color: #fff;
    font-size: 14px;
  }
  .footert{
    text-align: center;
    line-height: 30px;
    margin-bottom: 20px;
    a{
      color: #fff;
    }
  }
  .footerbl{
    width: 63px;
    margin: 7px 58px 0 258px;
    display: inline-block;
  }
  .footerbr{
    line-height: 2;
  }
  .footerbla{
    color: #fff;
    font-size: 14px;
    text-align: center;
    margin-right: 95px;
    img{
      width: 90px;
      height: 90px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/layout/foot.vue